import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=0b14541a&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b14541a')) {
      api.createRecord('0b14541a', component.options)
    } else {
      api.reload('0b14541a', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=0b14541a&", function () {
      api.rerender('0b14541a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/sidebar/Chat.vue"
export default component.exports